import type { FC } from "react";
import { cn } from "../utils";
import { Alert, AlertDescription, AlertTitle } from "./alert";

export interface ErrorProps {
  className?: string;
  error?: { message?: string };
  title?: string;
  message?: string;
}

export const Error: FC<ErrorProps> = ({ className, error, title, message }) => (
  <div className={cn("w-full", className)}>
    <Alert variant="destructive" icon="error" className="h-auto">
      <AlertTitle>{title || "Error"}</AlertTitle>
      <AlertDescription>{message || error?.message}</AlertDescription>
    </Alert>
  </div>
);
